import { render, staticRenderFns } from "./TheSearchElement.vue?vue&type=template&id=0988b628&scoped=true"
import script from "./TheSearchElement.vue?vue&type=script&lang=js"
export * from "./TheSearchElement.vue?vue&type=script&lang=js"
import style0 from "./TheSearchElement.vue?vue&type=style&index=0&id=0988b628&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0988b628",
  null
  
)

export default component.exports